export default __webpack_public_path__ + "static/media/019-nest.ce16b039.svg";